/**
* @prop --uic-footer-menu-border: the border of the menu
* @prop --uic-footer-menu-background: the background of the menu
* @prop --uic-footer-menu-item-gap: the distance between menu items
* @prop --uic-footer-menu-button-z-index: the z-index of the button
*/

.uic-footer-menu {
    display: contents;

    &__button {
        min-width: calc(var(--uic-button-min-width) + 50px);

        > uic-button {
            width: 100%;
        }
    }

    &__popover[open] &__button {
        --uic-button-footer-text-color: var(--uic-color-blue1);
        --uic-button-footer-text-color-hover: var(--uic-color-blue1);
        --uic-button-footer-text-color-focus: var(--uic-color-blue1);
        --uic-button-footer-border-color: transparent;
        --uic-button-footer-border-color-hover: transparent;
        --uic-button-footer-border-color-focus: transparent;
        --uic-button-footer-border-color-active: transparent;
        --uic-button-footer-background-color: transparent;
        --uic-button-footer-background-color-active: transparent;
        position: relative;
        z-index: var(--uic-footer-menu-button-z-index);
    }

    &__items {
        box-sizing: border-box;
        display: flex;
        flex-flow: column nowrap;
        gap: var(--uic-footer-menu-item-gap);
        padding: calc(var(--uic-footer-menu-item-gap) / 2);
        background: var(--uic-footer-menu-background);
        border: var(--uic-footer-menu-border);
        padding-bottom: calc(var(--uic-footer-menu-item-gap) + var(--uic-button-height));
        margin-bottom: calc(-1 * var(--uic-button-height) - var(--uic-footer-menu-item-gap));
    }
}
